import { motion } from "framer-motion";
import { ReactNode } from "react";

type PTagFramerProps = {
  children: ReactNode; // Optional children prop
};

export default function PTagFramer({
    
  children,
}: PTagFramerProps) {
      // Variants for individual dropdown items
  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
    exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
  };
  return <motion.p variants={itemVariants}>{children}</motion.p>;
}
